import React, {useState, useRef, useEffect} from "react"
import styled, {css, createGlobalStyle, keyframes}  from "styled-components"
import reset from "styled-reset-advanced"
import { Link, navigate } from "gatsby"

export const Tokens = {
    lg: '(max-width: 1280px)',
    md: '(max-width: 768px)',
    sm: '(max-width: 480px)'
}


export const GlobalStyle = createGlobalStyle`
  ${reset}
  /* other styles */
  :root {
    -webkit-font-smoothing: antialiased;
    --textBlack: #333333;
    --darkBlue: #222149;
    --darkGray: #9494a5;
    --white: #FFFFFF;
    --lightGray: #d6e5ff;
    --gray: #AFCAFA;
    --blue: #204b97;
    --green: #86fba1;
    --alphaBlack10: rgba(0,0,0,0.1);
    --alphaBlack20: rgba(0,0,0,0.2);
    --fontFamily: Inter, -apple-system, Helvetica, Arial, sans-serif;
    --normal: normal;
    --medium: 600;
    --bold: 700;
    --extraBold: 800;
    --fontSizeXXXL: 5rem; /* 80px */
    --fontSizeXXL: 2.5rem; /* 48px */
    --fontSizeXL: 2rem; /* 32px */
    --fontSizeL: 1.5rem; /* 24px */
    --fontSizeM: 1.25rem; /* 20px */
    --fontSizeS: 1rem; /* 16px */
    --fontSizeXS: 0.875rem; /* 14px */
    --fontSizeXXS: 0.75rem; /* 12px */
    --lg: '(max-width: 1280px)';
    --md: '(max-width: 768px)';
    --sm: '(max-width: 480px)';
    --customEasing: cubic-bezier(0.43, 0.13, 0.23, 0.96);
    --stackSpacingXXXL: 9rem;
    --stackSpacingXXL: 7rem;
    --stackSpacingXL: 5rem;
    --stackSpacingL: 3rem;
    --stackSpacingM: 2rem;
    --stackSpacingS: 1rem;
    --contentMaxWidth: 720px;
    --gridGap: 1.5rem;
    @media ${Tokens.md} {
      --fontSizeXXXL: 3rem; /* 80px */
      --fontSizeXXL: 1.8rem; /* 48px */
      --fontSizeXL: 1.7rem; /* 32px */
      --fontSizeL: 1.5rem; /* 24px */
      --fontSizeM: 1rem; /* 20px */
      --fontSizeS: 0.875rem; /* 16px */
      --fontSizeXS: 0.8rem; 
      --stackSpacingXXL: 4rem;
      --stackSpacingXL: 3rem;
      --stackSpacingL: 2rem;
      --gridGap: 1rem;
    }
  }
  body {
    font-size: var(--fontSizeM);
    font-family: var(--fontFamily);
    background: var(--gray);
    color: var(--darkBlue);
  }
  h1, h2, h3, h4 {
    font-weight: var(--bold);
  }
  h1 {
    font-size: var(--fontSizeXXL);
  }
  h2 {
    font-size: var(--fontSizeXL);
  }
  h3 {
    font-size: var(--fontSizeM);
    line-height: 1.4;
  }
  h4 {
    text-transform: uppercase;
    font-weight: var(--medium);
  }
  p {
    margin-top: 1.5rem;
    line-height: 1.6;
  }
  li {
    line-height: 1.4;
    margin-top: 0.8rem;
  }
  strong {
    font-weight: var(--medium);
  }
  .gatsby-resp-image-image {
    box-shadow: none !important;
  }
`

export const Container = styled.div`
    max-width: 1200px;
    /* padding: 0 32px; */
    padding: 0 2rem;
    margin: 0 auto;
`;



export const Grid = styled.div`
  display: grid;
  grid-template-columns: ${props => (props.template) ? props.template : 'repeat(12, 1fr)'};
  grid-column-gap: var(--gridGap);
  grid-row-gap: var(--gridGap);
  
`;


export const Col = styled.div`
  grid-column: ${props => props.start ? props.start + " /" : ""} ${props => props.span ? "span " + props.span : "auto"};
  ${props => props.spanMd && css`
    @media ${Tokens.md} { 
      grid-column: span ${props => props.spanMd};
      grid-row: auto !important;
    }
  `}
  ${props => props.spanSm && css`
    @media ${Tokens.sm} { 
      grid-column: span ${props => props.spanSm};
      grid-row: auto !important;
    }
  `}
`;


const baseButton = css`
  background: var(--alphaBlack10);
  color: var(--white);
  font-weight: var(--bold);
  padding: 0.5rem 0.7rem;
  border-radius: 0.5rem;
  display: inline-block;
  transition: all 0.1s;
  color: var(--darkBlue);
  &:hover {
    background: var(--alphaBlack20);
  }
  
`


export const ButtonLink = styled(Link)`
  ${baseButton};
`

export const ExternalButton = styled.a`
  ${baseButton};
`

export const DisabledButton = styled.button`
  ${baseButton};
  color: var(--alphaBlack20);
  &:hover {
    background: var(--alphaBlack10);
    cursor: not-allowed;
  }
`

const StyledExternalLink = styled.a`
  transition: all 0.2s;
  background: transparent;
  border-radius: 8px;
  padding: 2px 10px;
  margin-left: -10px;
  margin-right: -10px;
  display: inline-block;
  
  &:hover {
    background: var(--alphaBlack10);
  }
  &:active {
    background: var(--alphaBlack20);
  }
`


export const ExternalLink = (props) => {
  return (
    <StyledExternalLink href={props.href} target="__blank">{props.name} ↗</StyledExternalLink>
  )
}

export const FixedBackButton = styled(Link)`
  position: fixed;
  margin-left: -7rem;
  top: 4rem;
`

export const FixedBackButtonFromHome = styled.a`
  position: fixed;
  margin-left: -7rem;
  top: 4rem;
  cursor: pointer;
`

const StyledBackButton = styled.svg`
  transition: transform 0.2s;
  &:hover {
    transform: scale(1.2);
  }
`

export const BackButton = (props) => {
  let svg = <StyledBackButton width={48} height={48} viewBox="0 0 48 48" fill="none">
    <circle cx={24} cy={24} r={24} style={{fill: 'var(--white)'}} fillOpacity={1} />
    <path
      d="M26.4 16l-8 8.242 8 7.758"
      style={{stroke: 'var(--darkBlue)', strokeWidth: '4', strokeLinejoin: 'round'}}
    />
  </StyledBackButton>;
  

    return (
      (props.fromHome) ? <FixedBackButtonFromHome onClick={() => { navigate(-1) }}>{svg}</FixedBackButtonFromHome> : <FixedBackButton to={(props.to) ? props.to : "/"}>{svg}</FixedBackButton>

    );
}


export const wiggleAnimation = keyframes`
    0% {
        transform: translateY(-0.2rem);
    }
    50% {
        transform: translateY(0.2rem);
    }
    100% {
        transform: translateY(-0.2rem);
    }
`;


const slideInKeyframes = (y) => keyframes`
  from {
    opacity: 0;
    transform: translateY(${y});
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`
const StyledSlideIn = styled.div`
  opacity: 0;
  visibility: hidden;
  &.animated {
    visibility: visible;
    animation: ${props => (props.distance) ? slideInKeyframes(props.distance) : slideInKeyframes('100px')} ${props => (props.duration ? props.duration + 's' : '0.3s')} var(--customEasing);
    animation-delay: ${props => (props.delay) ? props.delay + 's' : '0s'};
  }
  &.completed {
    visibility: visible;
    opacity: 1;
    transform: translateY(0);
  }
`;

export const SlideIn = props => {
  const ref = useRef();
  
  useEffect(() => {
      if(((props.trigger && props.trigger === true) || typeof props.trigger === 'undefined') && !ref.current.classList.contains('completed')) {
        ref.current.classList.add('animated');
        const handleAnimationEnd = (event) => {
          event.target.classList.add('completed');
        };
        ref.current.addEventListener('animationend', handleAnimationEnd);
      }
  });
  return <StyledSlideIn ref={ref} className="slidein" {...props}>{props.children}</StyledSlideIn>
};

export const FadeIn = (props) => {
  const replaceDistance = {distance: '0px'};
  const newProps = {...props, ...replaceDistance};
  return (
      <SlideIn {...newProps}>{props.children}</SlideIn>
  );
}

const TextContainer = styled.div`
    display: inline-flex;
    overflow: hidden;
    line-height: 1.2;
    .slidein {
        display: inline-block;
    }
    
`


export const AnimationText = (props) => {
 
  return (
      <TextContainer>
      <SlideIn {...props}>{props.children}</SlideIn>
      {/* <motion.div className="slidein" variants={variants}
      transition={{
        duration: (props.duration) ? props.duration : 0.6,
        ease: [0.43, 0.13, 0.23, 0.96]
      }}>{props.children}</motion.div> */}
      </TextContainer>
  );
  
}

const VideoWrapper = styled.video`
  width: 100%;
  height: auto;
`;
export const Video = (props) => {
  // const [ref, inView, entry] = useInView({
  //   threshold: 0.5
  // });
  // const [playing, setPlaying] = useState(false);
  // useEffect(() => {
  //   if(inView) {
  //     entry.target.play();
  //     setPlaying(true);
  //   } else {
  //     if (playing === true) entry.target.pause();
  //   }

  // }, [inView]);
  return (
    <VideoWrapper poster={props.poster && props.poster} src={props.src} width={props.width ? props.width : undefined} height={props.height ? props.height: undefined} loop muted autoPlay playsInline preload="true"></VideoWrapper>
  );
  // if(inView) {
  //   // let playPromise = entry.target.play();
  //   setPlaying(entry.target.play());
  // } else {
  //   if (playing !== undefined) {
  //     playing.then(_ => {
  //       // Automatic playback started!
  //       // Show playing UI.
  //       // We can now safely pause video...
  //       entry.target.pause();
  //     })
  //     .catch(error => {
  //       // Auto-play was prevented
  //       // Show paused UI.
  //     });
  // }
}

const StyledBrowser = styled.div`
    border-radius: 1rem;
    box-shadow: 0 6px 40px rgba(0,0,0,0.07);
    width: 100%;
    header {
        border-radius: 1rem 1rem 0 0;
        background: rgba(255,255,255,0.8);
        height: 2rem;
        display: flex;
        align-items: center;
        font-size: var(--fontSizeS);
        font-weight: var(--medium);
        color: var(--darkGray);
        address {
            height: 1rem;
            border-radius: 1rem;
            width: 40%;
            margin-right: 50%;
            transform: translateX(50%);
            display: inline-block;
            background: rgba(0,0,0,0.04);
        }
        span {
            width: 12px;
            height: 12px;
            border-radius: 12px;
            background: var(--alphaBlack10);
            display: block;
            margin-right: 6px;
            &:first-child {
                margin-left: 12px;
            }
            &:last-child {
                margin-right: 1rem;
            }
        }    
    }
    main {
        border-radius: 0 0 1rem 1rem;
        overflow: hidden;
        transform: translateZ(0); // overflow hidden hack;
    }
    main > * {
        width: 100%;
        /* border-radius: 0 0 1rem 1rem; */
    }
`

export const Browser = props => {
    return (
        <StyledBrowser>
        <header>
        <span></span><span></span><span></span>{props.title && props.title}{props.address && <address></address>}
        </header>
        
        <main>
        {props.children}
        </main>
        </StyledBrowser>
    )
}

export const useWindowSize = () => {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    
    // Add event listener
    window.addEventListener("resize", handleResize);
    
    // Call handler right away so state gets updated with initial window size
    handleResize();
    
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount

  return windowSize;
}